import { useCallback } from "react";
import copy from "copy-to-clipboard";
import { useToast } from "./useToast.ts";

export function useCopyToClipboard() {
  const showToast = useToast();
  return useCallback(
    (text: string, copiedMessage = "Copied to clipboard") => {
      copy(text);
      showToast(copiedMessage);
    },
    [showToast],
  );
}
